export default __webpack_public_path__ + "static/media/busd.488237bc.svg";